import { SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
import { DeleteDeviceTrustedParams } from '@repo/user-types'

const initialDeleteDeviceTrustedState: GenericOperationState<null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: deleteDeviceTrustedDataActions, reducer: deleteDeviceTrustedDataReducer } =
  createOperationSlice<
    null,
    SliceCaseReducers<GenericOperationState<null>>,
    DeleteDeviceTrustedParams
  >({
    name: '@users/devices/delete-trusted',
    initialState: initialDeleteDeviceTrustedState,
    reducers: {},
  })
